import { isTerminalPurchaseState } from '../../containers/Subscription/Common/paymentStateHelpers';
import types from './types';

export const initialState = {
  isPaymentScreenVisible: false,
  paymentProcessing: null,
  purchasePaymentResult: null,
  vatVerification: {
    isFetching: false,
    isVerified: false,
  },
  videoMobileCode: {
    activation: {
      data: {},
      error: 0,
      isFetching: false,
    },
  },
  videoMobileLicense: {
    didInvalid: false,
    error: null,
    isFetching: false,
    prices: {
      data: null,
      didInvalid: false,
      error: null,
      isFetching: false,
    },
  },
};

const resetIfTerminalResult = (state) =>
  isTerminalPurchaseState(state.purchasePaymentResult?.purchaseState)
    ? { paymentProcessing: null, purchasePaymentResult: null }
    : {};

const reducers = {
  [types.SET_PAYMENT_SCREEN_VISIBLE]: (state, { payload }) => ({
    ...state,
    isPaymentScreenVisible: payload,
    ...(payload ? {} : resetIfTerminalResult(state)),
  }),

  [types.DISMISS_TERMINAL_PAYMENT_RESULT]: (state) => ({
    ...state,
    ...resetIfTerminalResult(state),
  }),

  [types.GET_VAT_VERIFICATION_REQUEST]: (state) => ({
    ...state,
    vatVerification: {
      ...state.vatVerification,
      isFetching: true,
    },
  }),

  [types.GET_VAT_VERIFICATION_SUCCES]: (state) => ({
    ...state,
    vatVerification: {
      ...state.vatVerification,
      isFetching: false,
      isVerified: true,
    },
  }),

  [types.GET_VAT_VERIFICATION_ERROR]: (state) => ({
    ...state,
    vatVerification: {
      ...state.vatVerification,
      isFetching: false,
      isVerified: false,
    },
  }),

  [types.GET_MOBILE_VIDEO_LICENSE_FAILURE]: (state, { error }) => ({
    ...state,
    videoMobileLicense: {
      ...state.videoMobileLicense,
      error,
      isFetching: false,
    },
  }),

  [types.GET_MOBILE_VIDEO_LICENSE_PRICES_SUCCESS]: (state, { payload }) => ({
    ...state,
    videoMobileLicense: {
      ...state.videoMobileLicense,
      prices: {
        data: payload,
        didInvalid: true,
        error: null,
        isFetching: false,
      },
    },
  }),

  [types.GET_MOBILE_VIDEO_LICENSE_PRICES_FAILURE]: (state, { error }) => ({
    ...state,
    videoMobileLicense: {
      ...state.videoMobileLicense,
      prices: {
        data: null,
        didInvalid: false,
        error,
        isFetching: false,
      },
    },
  }),

  [types.SET_PAYMENT_RESULT]: (state, { payload }) => {
    if (isTerminalPurchaseState(payload?.purchaseState) && !state.isPaymentScreenVisible) {
      return { ...state, paymentProcessing: null, purchasePaymentResult: null };
    }
    return { ...state, purchasePaymentResult: payload };
  },

  [types.SET_PAYMENT_PROCESSING]: (state, { payload }) => ({
    ...state,
    paymentProcessing: payload,
  }),

  [types.INVALIDATE_CODE_DATA]: (state) => ({
    ...state,
    videoMobileCode: initialState.videoMobileCode,
  }),

  [types.ACTIVATE_ACTIVATION_CODE_REQUEST]: (state) => ({
    ...state,
    videoMobileCode: {
      ...state.videoMobileCode,
      activation: {
        ...initialState.videoMobileCode.activation,
        isFetching: true,
      },
    },
  }),

  [types.ACTIVATE_ACTIVATION_CODE_SUCCESS]: (state, { payload }) => ({
    ...state,
    videoMobileCode: {
      ...state.videoMobileCode,
      activation: {
        ...initialState.videoMobileCode.activation,
        data: payload,
        isFetching: false,
      },
    },
  }),

  [types.ACTIVATE_ACTIVATION_CODE_ERROR]: (state, { error }) => ({
    ...state,
    videoMobileCode: {
      ...state.videoMobileCode,
      activation: {
        ...initialState.videoMobileCode.activation,
        error: error?.status,
        isFetching: false,
      },
    },
  }),
};

const reducer = (state = initialState, action = {}) => {
  if (reducers[action.type]) {
    return reducers[action.type](state, action);
  }
  return state;
};

export default reducer;
